
import React from "react";
import { ShieldCheck, Users, Clock, BookUser, Award, Star } from "lucide-react";

const TrustElements = () => {
  return (
    <div className="mt-8 p-5 bg-gradient-to-br from-blue-50/30 to-slate-50 border border-slate-200/60 rounded-lg shadow-sm">
      <h3 className="font-medium text-slate-700 mb-3">Vertrauen & Professionalität</h3>
      <ul className="space-y-3">
        <li className="flex items-start gap-2">
          <ShieldCheck className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" />
          <span className="text-sm text-slate-600">Höchste Vertraulichkeit und professionelle Datenbehandlung</span>
        </li>
        <li className="flex items-start gap-2">
          <Clock className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" />
          <span className="text-sm text-slate-600">Antwort innerhalb von 48 Stunden</span>
        </li>
        <li className="flex items-start gap-2">
          <BookUser className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" />
          <span className="text-sm text-slate-600">Orientierung an ethischen Standards der ICF</span>
        </li>
        <li className="flex items-start gap-2">
          <Users className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" />
          <span className="text-sm text-slate-600">Persönliche Betreuung ohne Call-Center</span>
        </li>
      </ul>
    </div>
  );
};

export default TrustElements;
